import React from 'react';
import AboutFeatured from '../components/AboutFeatured';
import Approch from '../components/Approch';
import ContactForm from '../components/ContactForm';
import ContactUs from '../components/ContactUs';
import Cta from '../components/Cta';
import Faq from '../components/Faq';
import Footer1 from '../components/Footer1';
import Header1 from '../components/Header1';
import Hero1 from '../components/Hero1';
import Process from '../components/Process';
import Services1 from '../components/Services1';

function Home1() {
    return (
        <>
            <Header1 />
            <Hero1 />
            <div id="about">
                <AboutFeatured />
                <Approch />
            </div>
            <div id="services">
                <Services1 />
            </div>
            <Process />
            <Cta />
            <Faq />
            <div id="contact">
                <section className="section-padding pt-0">
                    <div className="container">
                        <div className="row">
                            <div className="col-12">
                                <div className="section-title text-center">
                                    <span>Contact Us</span>
                                    <p>Get In Touch</p>
                                    <h1>Let's Work Together</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <ContactUs />
                <ContactForm title="Write Message" heading="Send Us a Message" />
            </div>
            <Footer1 />
        </>
    );
}

export default Home1;
